<template>
  <nav class="nav-bar">
    <main class="maxW">
      <div
        v-for="item in navList"
        :key="item.path"
        @click="goToPath(item.path)"
      >{{ item.label }}</div>
    </main>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          label: this.$t("customer.home"),
          path: "/customer-home",
        },
      ],
    };
  },
  methods: {
    goToPath(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped lang='scss'>
.nav-bar {
  background-color: #fff;
  user-select: none;
  height: 48px;
  overflow: hidden;
  main {
    display: flex;
    height: 4rem;
    line-height: 4rem;

    div {
      color: #e62125;
      font-size: 1.4rem;
      font-weight: 800;
      letter-spacing: 0.2rem;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
      &:after {
        content: "";
        display: block;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 0.5rem;
        background-color: #e62125;
        position: relative;
        top: -0.8rem;
        left: calc(50% - 0.25rem);
      }
    }
  }
}
</style>
